import { Tag } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'

export interface V1TagCategory {
  tagCategoryName?: string | number
  tagName?: Array<string | number>
  [property: string]: any
}
interface TagDetailProps {
  resourceTagList?: V1TagCategory[]
}
export const TagDetail = (props: TagDetailProps) => {
  const { resourceTagList } = props

  return (
    <StyledTagDetail>
      <div className="title">{t('用例标签：')}</div>
      {resourceTagList?.map((item, index) => (
        <div className="content-cell">
          <div key={index} className="cell">
            {/* 后端返回字段不一致，蛇形 */}
            {item.tag_category_name && (
              <>
                <div className="categoryName ">{item.tag_category_name || ''}</div>
                <div>
                  {item.tag_list &&
                    item.tag_list.map((i, k) => (
                      <Tag key={k} className="tag">
                        {i.tag_name}
                      </Tag>
                    ))}
                </div>
              </>
            )}
            {/* 后端返回字段不一致，大驼峰 */}
            {item.tagCategoryName && (
              <>
                <div className="categoryName ">{item.tagCategoryName || ''}</div>
                <div>
                  {item.tagList &&
                    item.tagList.map((i, k) => (
                      <Tag key={k} className="tag">
                        {i.tagName}
                      </Tag>
                    ))}
                </div>
              </>
            )}
          </div>
        </div>
      ))}
    </StyledTagDetail>
  )
}

const StyledTagDetail = styled.div`
  margin-bottom: 24px;
  .flex {
    display: flex;
  }
  .title {
    eight: 14px;
    font-size: 14px;
    color: #86909c;
    line-height: 16px;
    width: 92px;
    text-align: left;
    margin-right: 18px;
    white-space: nowrap;
    margin-bottom: 15px;
  }
  .content-cell {
    width: 100%;
    margin: 0;
    color: #333;
    border-radius: 4px;
    line-height: 1.2;
    padding: 10px;
    background: #f7f8fa;
    word-break: break-all;
    word-wrap: break-word;
    white-space: pre-wrap;
    margin-top: 10px;
    .cell {
      .categoryName {
        color: #333;
        font-size: 14px;
      }
      .tag {
        font-size: 14px;
        margin-top: 10px;
        background: #ededed;
        color: #333;
        border: none;
      }
    }
  }
`
